import { render } from "./accessoire_selection.vue?vue&type=template&id=0e1118a2"
import script from "./accessoire_selection.vue?vue&type=script&lang=js"
export * from "./accessoire_selection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Site résa/reservation.ogalo-saumurvaldeloire.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__